import { useAuth } from './useAuth';

interface NavItem {
  path: string;
  label: string;
  icon: React.ComponentType;
  roles: string[];
}

export function useRoleNavigation(items: NavItem[]) {
  const { user } = useAuth();
  const userRole = user?.role || '';
  return items.filter(item => item.roles.includes(userRole));
}
